import { getDocumentElement, getDocumentElements } from "../Utils/Utils";

const OpenCloseNavigation = () => {
  const toggleButton = getDocumentElement('.farm-calc-top-navigation__button');
  const navList = getDocumentElement('.farm-calc-top-navigation__list');
  const navButtons = getDocumentElements('.farm-calc-top-navigation__list-link');

  if (!toggleButton || !navList || !navButtons.length) return;

  toggleButton.setAttribute('aria-expanded', 'false');
  navList.setAttribute('aria-hidden', 'true');

  toggleButton.addEventListener('click', () => {
    const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
    toggleButton.setAttribute('aria-expanded', String(!isExpanded));
    navList.setAttribute('aria-hidden', String(isExpanded));
    navList.classList.toggle('nav-active');
  });

  navButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      setTimeout(() => {
        toggleButton.setAttribute('aria-expanded', 'false');
        navList.setAttribute('aria-hidden', 'true');
        navList.classList.remove('nav-active');
      }, 0);
    });
  });
};

export default OpenCloseNavigation;
